import React from 'react';
import {
  formatMoneyAutoDecimal,
  NSB_SKY_REWARDS_LOZENGE_TEXT,
  SPLITIO_KEY,
  TANDC_URL,
  useSplitIO,
} from '@sky-tv-group/shared';
import { documentToReactComponents } from '@contentful/rich-text-react-renderer';
import { Coupon, ImageDetails } from '@sky-tv-group/graphql';
import { ReactComponent as BlackTick } from '../assets/black-tick.svg';

export interface HomePagePromotionaCardDetails {
  bgColor?: string | null;
  billingFrequency?: string | null;
  campaign?: string | null;
  coupon?: Coupon | null;
  disclaimer?: string | null;
  discountText?: string | null;
  discountedPrice: number | null;
  fromPrice?: string | null;
  imageSrc?: ImageDetails | null;
  lozengeText?: string | null;
  sku?: string | null;
  occurrenceType?: string | null;
  subtitle?: string | null;
  termsAndConditions?: any | null;
  title: string;
  type?: string | null;
  copyrightText?: string | null;
  descriptionList?: string[] | null;
  iconList?: ImageDetails[] | null;
  addLinkText?: string | null;
  addLink?: string | null;
  detailsText?: string | null;
  detailsLink?: string | null;
  promotionImage?: ImageDetails | null;  
}

export interface HomePagePromotionalCardProps {
  card: HomePagePromotionaCardDetails;
  buttons?: React.ReactNode;
  bgColor?: string;
  fixedWidth?: number;
  showBottomGradient?: boolean;
  cardType?: 'PRODUCT' | 'OFFER';
  compactMode?: boolean;
}

function wrapDecimalInSpan(num: number): string {
  const [whole, decimal] = num.toFixed(2).split('.');
  return `${whole}<span class="text-lg" style="line-height: 0; margin-top: 19px;">.${decimal}</span>`;
}

export function HomePagePromotionalCard({
  card,
  buttons,
  bgColor,
  compactMode,
  fixedWidth,
  cardType = 'OFFER',
}: HomePagePromotionalCardProps) {
  const [showCompetitionFlag] = useSplitIO(SPLITIO_KEY.SKYWEB_SHOW_PROMO_COMPETITION);
  const showCompetition = showCompetitionFlag && card.lozengeText === NSB_SKY_REWARDS_LOZENGE_TEXT;
  return (
    <div
      className="relative flex flex-col generic-promotional-card w-full"
      style={{
        top: card.lozengeText ? "-40px" : "",
        width: fixedWidth ?? undefined,
        border: card.lozengeText ? "3px solid #00013A" : "2px solid #A6A6A6",
        // boxShadow: card.lozengeText ? "8px  radial-gradient(148.99% 133.01% at 110.9% -11.1%, #01003D 0%, #0C2277 23.46%, #163EA7 36.65%, #1A49BA 47.59%, #1851BF 56.17%, #0C97E4 100%) " : 'none',
        borderRadius: "8px",
        borderImageSource: undefined,      
        borderImageSlice: card.lozengeText ? 1 : 'none',
        
    }} id="slickId">
      {/* Rounded Image as Absolute Element */}
      {/* {card?.promotionImage?.url ? (
              <img
              src={card?.promotionImage?.url}
              alt={card?.promotionImage?.text ?? ''}
              style={{
                position: "absolute",
                top: "-35px",
                right: "12px",
                width: "90",
                height: "90", 
                zIndex: 1,
              }}
            />
          ) : null} */}

      {/* {card?.lozengeText ? (<div style={{ height: '3px' }}></div>) : null} */}
     
      <div className="flex flex-col justify-start items-center gap-4">
        <div className={`flex flex-col gap-4 bg-gray-light px-4 py-6`} style={{borderRadius: card.lozengeText ? "0px 8px 0 0" : "8px 8px 0 0",background: card.lozengeText ? "radial-gradient(122.33% 88.73% at 110.9% -11.1%, #0C97E4 0%, #1A49BA 50%, #163EA7 59%, #0C2277 79%, #01003D 100%)" : "#F2F2F2"  ,minHeight: '390px' }}>
        {card?.occurrenceType === 'Data' && (
          <div className="flex items-center pt-3 text-black">
            <img className="mr-2 mb-2" src={'https://static.sky.co.nz/sky/icons/icon-color-wifi.svg'} alt="" />
            <span className="sky-h5-black mr-2"> UNLIMITED </span> fibre
          </div>
        )}
        <div style={{minHeight:'100px'}}>
        <h5 style={{ lineHeight: '34px', minHeight: '62px' }} className={`${card.lozengeText ? 'text-white ' : 'text-black '} font-skyBlack text-[28px] md:text-[28px]`}>
          {card?.title}
        </h5>
        </div>
        <div className={`${card.lozengeText ? 'text-white' : 'text-black'}`} style={{minHeight:'81px'}}>
          {
            (card?.fromPrice !== card?.discountedPrice && card?.fromPrice) ?
              (<p className={`line-through ${card.lozengeText ? 'text-pink' : 'sky-text-red'}` } style={{ fontSize: '18px', lineHeight: '125%' }}>
                {formatMoneyAutoDecimal(+card.fromPrice)}
              </p>) : <div style={{ height: '18px' }}></div>}
          {card?.discountedPrice !== null ? (
            <div>
              <div className='flex flex-row items-center justify-between'>
              <div className="ml-4 pr-2 mr-8 relative inline-block">
                <span
                  className="font-skyBlack absolute "
                  style={{ fontSize: 20, lineHeight: '24px', right: '100%', top: 6 }}>
                  $
                </span>
                <span className="font-skyBlack" style={{ fontSize: 46, lineHeight: '56px' }}>
                  <span
                    className="flex flex-row items-start"
                    dangerouslySetInnerHTML={{
                      __html: wrapDecimalInSpan(+formatMoneyAutoDecimal(card.discountedPrice).substring(1)),
                    }}
                  />
                </span>
                {card?.billingFrequency === 'Monthly' && (
                  <span
                    className=" absolute  "
                    style={{ fontSize: 12, lineHeight: '16px', left: 'calc(100% - 33px)', bottom: 6 }}>
                    /mth
                  </span>
                )}
                {card?.billingFrequency === 'One Time Payment' && (
                  <span
                    className="absolute min-w-28"
                    style={{ fontSize: 12, lineHeight: '16px', left: 'calc(100% - 33px)', bottom: 6 }}>
                    /one-off charge
                  </span>
                )}
              </div>
              {card.discountText &&
            (<div><div
              className="z-10 overflow-hidden "
              style={{
                borderRadius: '4px',
                transform: 'skew(-15deg)',
                transformOrigin: '0 0',
                marginTop: `0px`,
                marginLeft: `0px`,
                width:'166px'
              }}>
              <div
                className="font-skyBook text-white whitespace-pre-line"
                style={{
                  fontSize: '14px',
                  lineHeight: '18px',
                  padding: '8px',
                  wordBreak: 'keep-all',
                  whiteSpace: 'nowrap',
                  background: card.lozengeText ?'#F94CB1':'#9100D4',
                  borderRadius: '4px',
                  transform: 'skew(15deg)',
                  transformOrigin: '0 0',
                  perspective: '1px',
                }}>
                {card.discountText}
              </div>
              
            
          </div>
          <div className={`${card.lozengeText ? 'text-white ' : 'text-black '}font-skyBook  whitespace-pre-line`} style={{ fontSize: '12px',fontWeight:'450', lineHeight: '125%', marginTop: '8px',}}>
            {card?.subtitle}
            </div>
          </div>)}
            
            </div>
            </div>
          ) : null}
         
           
        </div>
        <div>
        {card?.imageSrc?.url ? (
        <img
          style={{ borderRadius: '8px' }}
          src={card?.imageSrc?.url}
          alt={card?.imageSrc?.text ?? ''}
          className={`w-full object-center ${cardType === 'PRODUCT' ? 'object-contain' : 'absolute left-0 top-0 h-full object-contain'
            }`}
        />
      ) : null}
        </div>
        </div>
          
          <div className='flex flex-col justify-center items-center px-4 gap-2 ' style={{minHeight:'285px'}}>
          <div className='flex flex-col' style={{minHeight: card.lozengeText ? '168px' :'195px'}}>
          {card?.descriptionList && card?.descriptionList?.length && (
            <ul className="flex-grow mt-sky-xs">
              {card?.descriptionList &&
                card?.descriptionList?.map((item: any, index: number) => {
                  return (
                    <li
                      style={{ paddingLeft: 20,}}
                      className={`relative text-left tick sky-h7 text-black text-[14px] mb-sky-xs ${(card?.descriptionList && card?.descriptionList?.length-1 === index) && 'font-bold'}`}
                      key={`${index}-${item}`}>
                      <span className="absolute left-0" style={{ top: 2, width: 14, height: 14 }}>
                        <BlackTick className="mr-sky-sm w-full" />
                      </span>

                      {item}
                    </li>
                  );
                })}
            </ul>
          )}
          </div>
          <div style={{minHeight:  '40px' }}>
          {card?.termsAndConditions ? (
            <p className="" style={{ fontSize: 10, lineHeight: '12px' }}>
              {documentToReactComponents(card?.termsAndConditions)}
            </p>
          ) : null}
          {card?.disclaimer ? (
            <p className="" style={{ fontSize: 6, lineHeight: '8px' }}>
              {card.disclaimer}
            </p>
          ) : null}
          {showCompetition && (
            <p className="" style={{ fontSize: 10, lineHeight: '12px' }}>
              Competition <a href={TANDC_URL}>T&Cs</a> apply.
            </p>
          )}
         </div>
      
      {buttons ? <div className={`${compactMode ? 'mt-auto' : 'bottom-0'}  w-full`} style={{minHeight:'40px'}}>{buttons}</div> : null}
      </div>
    </div>
    </div>
  );
}
